const styles = {
  explanation: { mt: { xs: -1, lg: -2 }, mb: 3 },
  formatsContainer: {
    display: 'flex',
    gap: { xs: 2, lg: 3 },
    flexDirection: { xs: 'column', md: 'row' },
  },
  formatItem: {
    width: { xs: '100%', lg: 536 },
    overflow: 'hidden',
  },
  container: {
    width: '100%',
    height: { xs: 232, lg: 300 },
    p: 2,
    position: 'relative',
    overflow: 'hidden',
    color: 'kit.text.mainInverse',
  },
  imageWrapper: {
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 0,
    width: '100%',
    height: '100%',
    borderRadius: 3,
    overflow: 'hidden',
  },
  contentContainer: {
    zIndex: 1,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  profession: {
    padding: '2px 4px 4px 4px',
    display: 'inline-block',
    backgroundColor: '#FFFFFF24',
    borderRadius: '4px',
  },
  duration: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    ml: 'auto',
  },
  startDate: {
    display: 'flex',
    gap: 1,
    alignItems: 'center',
    mt: 1.5,
  },
};

export default styles;
